import React, { Component } from "react"
import { observer }          from "mobx-react"
import { withRouter }        from "react-router-dom"
import { Button, Modal }     from "semantic-ui-react"
import shop                  from "shop/shop"

@withRouter
@observer
export default class OrderlistSelectionV2 extends Component {

  get store() {
    return shop.store.orderlistV2
  }

  get service() {
    return shop.orderlistV2
  }

  addToList = ( id ) => {
    const { store, service } = this
    const list    = service.lists[ id ]
    const product = store.currentProduct

    if ( list && product ) {
      list.add( product )
      list.save()
      store.toggleSelectionModal()
      shop.toast( translate( "Produkt hinzugefügt" ), "info", false, "bottom" )
    }
  }

  render() {
    const { store, service } = this
    if ( !store || !service ) return null

    const { lists, listIds } = service

    return (
      <Modal
        centered={false}
        open={store.isOpenSelectionModal}
        className="ModalLoginPage__OrderList"
        onClose={store.toggleSelectionModal}
        style={{ borderRadius: 20, position: "fixed", top: "10%" }}
        size="small"
      >
        <Modal.Header>
          {translate( "Merkliste auswählen" )}
        </Modal.Header>

        <Modal.Content>
          {listIds.map( id => {
            const list = lists[ id ]
            if ( !list ) return null
            return (
              <div key={id} className="mb2">
                <Button
                  fluid
                  primary
                  onClick={() => this.addToList( id )}
                >
                  {list.customName || list.title}
                </Button>
              </div>
            )
          } )}
        </Modal.Content>

        <Modal.Actions>
          <div>
            <Button basic onClick={store.toggleSelectionModal}>
              {translate( "Zurück" )}
            </Button>
            <Button
              onClick={() => {
                this.props.history.push( "/orderlist" )
                store.toggleSelectionModal()
              }}
            >
              {translate( "Merklisten verwalten" )}
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Orderlist/OrderlistSelectionV2.js